import { ReactNode } from 'react';
import { Skeleton } from 'vopay';

/**
 * A field in the three states the Details tab can be in: `undefined` while the account loads, `null`
 * when the request failed, and the field itself once it arrived, where an empty string is a value
 * the account simply has no entry for.
 */
export type DetailValue = string | null | undefined;

/**
 * Loading, failed, missing, or the value itself; anything that is not a `DetailValue` renders as
 * given. Failed and missing both render the same dash: the distinction is the toast's to make, and
 * two different dashes down one card read as a typo rather than as two states.
 */
export function renderDetailValue(value: DetailValue | ReactNode): ReactNode {
  if (value === undefined) return <Skeleton width={120} height={18} />;
  if (value === null || value === '') return '-';

  return value;
}
